import MiniSearch from 'minisearch';

let cachedSearch = null;

export const buildSearchIndex = (posts) => {
  const miniSearch = new MiniSearch({
    fields: ['title', 'summary', 'categoryLabel', 'tags', 'headings'],
    storeFields: ['slug', 'title', 'summary', 'category', 'categoryLabel', 'date', 'tags', 'readingTime']
  });

  miniSearch.addAll(
    posts.map((post) => ({
      id: post.slug,
      slug: post.slug,
      title: post.title,
      summary: post.summary,
      category: post.category,
      categoryLabel: post.categoryLabel,
      date: post.date,
      tags: post.tags.join(' '),
      headings: post.headings.join(' '),
      readingTime: post.readingTime
    }))
  );

  return miniSearch;
};

export const getSearchEngine = (posts) => {
  if (!cachedSearch) {
    cachedSearch = buildSearchIndex(posts);
  }
  return cachedSearch;
};

export const searchPosts = (query, posts) => {
  if (!query || !query.trim()) return [];
  const engine = getSearchEngine(posts);
  return engine.search(query, {
    prefix: true,
    fuzzy: 0.2
  });
};
